<div class='exposed-map-container'>
  <div class='exposed-map-wrapper'>
    @if (loading) {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    }
    @if (displayContent) {
      <iframe
        id='exposed-map'
        type='text/html'
        src='https://demosmartgem.smart-gem.pl/exposed-map'
        width='100%'
        height='100%'>
      </iframe>
      <br>
      <div class='d-flex justify-content-end'>
        <button type='button' class='btn btn-secondary' (click)='close.emit(value); onChange(value)'>Zamknij</button>
      </div>
    }
  </div>
</div>
